<template>
    <div class="chart-container">
        <div class="primary-value">
            <div class="lga-value lg">
                {{ model.format(model.value) }}<span class="lga-units">{{ model.valueUnits }}</span>
            </div>
            <div class="label">
                <div class="inline-block">
                    {{ model.label }}
                </div>
            </div>
        </div>
        <dynamic-resize-container>
            <template
                #default="{width}"
            >
                <bar-chart
                    v-if="width > 0"
                    class="ranked-bar-chart"
                    :width="width"
                    :height="80"
                    :values="model.localRecords"
                    :label-values="[model.comparisonRecord]"
                    value-prop="value"
                >
                    <template
                        #tooltip-content="{ value }"
                    >
                        <div :class="`rbc-tooltip ${value.type === 'value' ? 'tooltip-lga' : ''} ${value.type === 'comparison' ? 'tooltip-compare' : ''}`">
                            <div class="tooltip-label">
                                {{ value.geographyName }} {{ value.type === 'comparison' && model.comparisonLabel === 'Zone' ? 'Zone' : '' }}
                            </div>
                            <div class="tooltip-value">
                                {{ model.formatWithUnits(value.value) }}
                            </div>
                        </div>
                    </template>
                    <template
                        #label-content="{ value }"
                    >
                        <tspan
                            :class="`compare-label ${value.value * model.options.positiveDirection < model.value * model.options.positiveDirection ? 'left' : 'right'}`"
                            dy="0.5em"
                        >
                            {{ model.formatWithUnits(value.value) }} in {{ model.comparisonLabel }}
                        </tspan>
                    </template>
                </bar-chart>
            </template>
        </dynamic-resize-container>

        <info-tooltip
            :definition="model.definition"
            :link-to-health="model.linkToHealth"
            :data-source="model.dataSource"
        />
    </div>
</template>

<script>
import DynamicResizeContainer from '@/components/DynamicResizeContainer.vue';
import BarChart from '@/components/BarChart.vue';
import InfoTooltip from '@/components/InfoTooltip.vue';

import MetricChartModel from '@/model/MetricChartModel';

export default {
    components: {
        DynamicResizeContainer, BarChart, InfoTooltip
    },
    props: {
        model: {
            type: MetricChartModel,
            required: true
        }
    }
};
</script>

<style src="./common.container.css" scoped></style>
<style lang="postcss" scoped>

.primary-value {
    @apply flex flex-row justify-start mb-2;
    align-items: baseline;
}

.ranked-bar-chart {
    @apply pb-4;
}

.label {
    @apply text-left;
}

.lga-value {
    @apply mr-2;
}

.rbc-tooltip:not(.tooltip-lga) {
    @apply text-neutral-label;
}
.rbc-tooltip.tooltip-compare:not(.tooltip-lga) {
    @apply text-neutral-text;
}

.tooltip-value {
    @apply text-xl font-bold leading-tight;
}
.tooltip-label {
    @apply text-xs leading-tight;
}

tspan.compare-label.left {
    text-anchor: end;
}
tspan.compare-label.right {
    text-anchor: start;
}

</style>
